import React from 'react';
import { SvgIconProps, Theme, SxProps } from '@mui/material';
import { useSelector } from 'react-redux';
import { ClientConfigState } from '../../../services/redux/clientConfigSlice';

interface IconWrapperProps extends SvgIconProps {
  expressConfig?: any;
  sx?: SxProps<Theme>;
}

const IconWrapper = ({
  children,
  expressConfig,
  sx,
  color = 'inherit',
  ...props
}: IconWrapperProps) => {
  // Get expressConfig from Redux
  const expressConfigObject = expressConfig
    ? expressConfig
    : useSelector(
        (state: { clientConfiguration: ClientConfigState }) =>
          state.clientConfiguration.configs,
      );

  // Get custom primary color from expressConfig if available
  const customPrimaryColor = expressConfigObject?.pruffConnect_styles_mainColor;

  // If color is 'primary' and we have a custom primary color, use it
  const iconColor =
    color === 'primary' && customPrimaryColor ? customPrimaryColor : color;

  return React.cloneElement(children as React.ReactElement, {
    ...props,
    color: iconColor,
    sx: {
      ...sx,
    },
  });
};

export default IconWrapper;
